import React, { Component } from 'react';

//componentes
import ConsultarNotas from './consultarNotas'

class Index extends Component {

    render(){
        return(
            <div>
                <ConsultarNotas />
            </div>
        );
    }

}
export default Index;